<template>
  <div class="details">
    <div class="orderDetailsT">
      <img src="static/images/left2.png" alt class="orderDetailsTReturn" @click="back" />
      <p>订单详情</p>
    </div>
    <div class="orderDetailsM">
      <div class="orderDetailsMT">
        <img :src="userinfo.head"  alt/>
        <p>{{orderinfo.shopName}}</p>
      </div>
      <ul class="orderDetailsMS">
        <li>
          <h4>交易单号</h4>
          <p>{{orderinfo.orderNumber}}</p>
        </li>
        <li>
          <h4>支付金额</h4>
          <p>{{orderinfo.amountActuals}}</p>
        </li>
        <li>
          <h4>支付方式</h4>
          <p>{{orderinfo.payTypes}}</p>
        </li>
        <li>
          <h4>下单时间</h4>
          <p>{{orderinfo.createTime}}</p>
        </li>
        <li>
          <h4>当前状态</h4>
          <p>{{orderinfo.statusDesc}}</p>
        </li>
      </ul>
    </div>
    <div class="detailsD">
      <div class="detailsDC" v-for="(item, index) in productlist" :key="index">
        <div class="detailsDCT" @click="showDetails(index)">
          <p>{{item.productName}}</p>
          <h4 style="font-size:0.24rem">X{{item.quantity}}</h4>
          <h4>
            ￥{{item.amountOriginals}}
            <img src="static/images/down.png"  alt/>
          </h4>
        </div>
        <ul class="detailsDCB" v-if="isDetails==index">
          <li>
            <h4>折扣</h4>
            <h5>{{item.discountName}}</h5>
          </li>
          <li>
            <h4>折扣金额</h4>
            <p><em>￥</em>{{item.amountDiscounts}}</p>
          </li>
        </ul>
      </div>
      <p class="detailsDP">实付：￥{{orderinfo.amountActuals}}</p>
    </div>
    
    
  </div>
</template>

<script>
import {orderInfo} from "../../api/api"
export default {
  name: 'orderDetails',
  data () {
    return {
      isDetails: 0,
      orderinfo: {},
      productlist: [],
      userinfo: {}
    }
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
    this.orderInfo()
    const data = sessionStorage.getItem("userinfo")
    const res = JSON.parse(data)
    this.userinfo = res
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    // 返回上一页
    back() {
      this.$router.go(-1)
    },
    showDetails(index){

      this.isDetails = index
    },
    // 订单详情
    orderInfo() {
      orderInfo(this, {orderId: this.$route.query.id}).then(res => {
        if(res.code == 200) {
          this.orderinfo = res.data
          this.productlist = res.data.shopOrderProductRespDTOList
        }
        console.log(res)
      })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>  
  
</style>



// WEBPACK FOOTER //
// src/components/order/details.vue